import { render, staticRenderFns } from "./AuditCustomFieldGroupList.vue?vue&type=template&id=4c61d5c4&scoped=true"
import script from "./AuditCustomFieldGroupList.vue?vue&type=script&lang=ts"
export * from "./AuditCustomFieldGroupList.vue?vue&type=script&lang=ts"
import style0 from "./AuditCustomFieldGroupList.vue?vue&type=style&index=0&id=4c61d5c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c61d5c4",
  null
  
)

export default component.exports